export default "__VITE_ASSET__Cey4ClnB__"